// Flag icon components for language switcher

interface FlagIconProps {
  className?: string;
  width?: number;
  height?: number;
}

export function FrenchFlag({ className = "w-5 h-5", width = 20, height = 15 }: FlagIconProps) {
  return (
    <svg
      viewBox="0 0 20 15"
      width={width}
      height={height}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="6.67" height="15" fill="#002654" />
      <rect x="6.67" width="6.67" height="15" fill="#FFFFFF" />
      <rect x="13.33" width="6.67" height="15" fill="#ED2939" />
    </svg>
  );
}

export function BritishFlag({ className = "w-5 h-5", width = 20, height = 15 }: FlagIconProps) {
  return (
    <svg
      viewBox="0 0 20 15"
      width={width}
      height={height}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Blue background - official UK blue (Pantone 280) */}
      <rect width="20" height="15" fill="#012169" />
      {/* White diagonal saltire (St Andrew) */}
      <path
        d="M 0 0 L 20 15 M 20 0 L 0 15"
        stroke="#FFFFFF"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="square"
      />
      {/* Red diagonal saltire (St Patrick) */}
      <path
        d="M 0.5 0 L 19.5 15 M 19.5 0 L 0.5 15"
        stroke="#C8102E"
        strokeWidth="0.8"
        fill="none"
        strokeLinecap="square"
      />
      {/* White fimbriation of St George's cross (1/15 of height) */}
      <rect x="7.5" y="0" width="5" height="15" fill="#FFFFFF" />
      <rect x="0" y="5" width="20" height="5" fill="#FFFFFF" />
      {/* Red cross of St George (1/5 of height) */}
      <rect x="8.5" y="0" width="3" height="15" fill="#C8102E" />
      <rect x="0" y="6" width="20" height="3" fill="#C8102E" />
    </svg>
  );
}



